import { DataContext } from 'App';
import { FC } from 'react';
import { Social } from '.';

export const SocialContainer: FC = () => (
	<DataContext.Consumer>
		{(dataContext): JSX.Element => <Social socialItems={dataContext.social} />}
	</DataContext.Consumer>
);
